import React from "react";
import useAtolInfoController from "./useAtolInfo.controller";
import { UIFlightData } from "@flights/types";
import { ATOLLogo } from "../../../../../ATOL/ATOLLogo";
import { Stack, Text } from "@bookingcom/bui-react";
import useRouteName from "../../../../../../../hooks/useRouteName";
import useProfiler from "../../../../../../../hooks/useProfiler";
import flights_web_condensed_extras_fd_mdot from "../../../../../../../utils/experiments/funnel/flights_web_condensed_extras_fd_mdot";

const useAtolInfo = (flight: UIFlightData) => {
  const { header, atolText } = useAtolInfoController(flight);

  const routeName = useRouteName();
  const { isMobile } = useProfiler();
  const condensedFDMobile =
    routeName == "flightdetails" && isMobile() && !!flights_web_condensed_extras_fd_mdot.trackWithDefaultStage();

  if (!atolText) return undefined;

  return {
    header,
    content: (
      <Stack direction="row" gap={4}>
        <ATOLLogo width={condensedFDMobile ? 20 : undefined} height={condensedFDMobile ? 20 : undefined} />
        <Stack.Item grow={true}>
          <Text variant="body_2">{atolText}</Text>
        </Stack.Item>
      </Stack>
    )
  };
};

export default useAtolInfo;
